import React from "react";

export const tags = {
    unity: { label: "Unity", style: "tag tag-unity" },
    unreal: { label: "Unreal", style: "tag tag-unreal"},
    csharp: { label: "C#", style: "tag tag-csharp" },
    cpp: { label: "C++", style: "tag tag-cpp" },
    blueprint: { label: "Blueprints", style: "tag tag-blueprints" },
    external: { label: "Outsourcing", style: "tag tag-external"},
    internal: { label: "In-house", style: "tag tag-internal" }
}

export default function Tags({ tags = [] }) {
    if (!tags.length) return null;

    return (
        <div className={`tags`.trim()}>
            {tags.map((tag) => (
                <span key={tag.label} className={tag.style}>
                    {tag.label}
                </span>
            ))}
        </div>
    );
}